<script setup>
import { defineProps, computed } from 'vue'

import enTranslations from '../../i18n/en_CA/error-messages.json'
import frTranslations from '../../i18n/fr_CA/error-messages.json'
import ContentContainer from '../../components/Layout/ContentContainer'
import EmptyState from '../emptyState/EmptyState.vue'

const i18n = {
  en: enTranslations,
  fr: frTranslations
}

const props = defineProps({
  locale: {
    type: String,
    required: true,
    validator: (value) => ['en', 'fr'].includes(value)
  },
  error: {
    type: String,
    required: true
  }
})

const title = computed(() => i18n[props.locale].errors[props.error]?.title ?? i18n[props.locale].errors.generic.title)
const description = computed(() => i18n[props.locale].errors[props.error]?.description ?? '')
const contactMessage = computed(() => i18n[props.locale].contactMessage)

</script>

<template>
  <ContentContainer>
    <div class="col-sm-10 col-md-8">
      <EmptyState
        :title="title"
        :content="`${description}<br>${contactMessage}`"
      />
    </div>
  </ContentContainer>
</template>
